import React, { useCallback } from "react";
import { Accordion, AccordionSummary, AccordionDetails, Box, Button, CircularProgress, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useTranslation } from "react-i18next";
import StabilityForm from "./Form";
import { SETTING_TABLE_NAME } from "Constants/settingsTableName";
import { useMsal } from "Auth/msal-context";
import { useKeyboard } from "../../../hooks/KeyboardContext";
import useSettings from "../../../hooks/useSettings";

const transformResponse = (res) => res.jsonData;

const StabilitySettings = () => {
  const { t } = useTranslation("common");
  const { isAuthorized, isEdge } = useMsal();
  const { registerInput } = useKeyboard();

  const { formState, setFormState, loading, error, fetchSettings, saveSettings, updateField, updateComponentField } =
    useSettings(SETTING_TABLE_NAME.STABILITY_SETTINGS, transformResponse);

  const onChangeHandler = useCallback((key, value, component) => {
    if (component === undefined) {
      updateField(key, value);
    } else {
      updateComponentField(component, key, value);
    }
  }, [updateField, updateComponentField]);

  const inputSelected = (e, name) => {
    const parts = name.split("|");
    if (parts[1] === "zeroTolerance" || parts[1] === "spanTolerance") {
      registerInput(name, e.target.value, (v) => onChangeHandler(parts[1], v, parts[0]));
    } else {
      registerInput(name, e.target.value, (v) => onChangeHandler(name, v));
    }
  };

  const handleSave = () => {
    if (!formState) return;
    saveSettings({ ...formState });
  };

  return (
    <Accordion sx={{ mb: 2 }} disableGutters onChange={(e, expanded) => { if (expanded) fetchSettings(); }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ bgcolor: "primary.main", color: "common.white" }}>
        <Typography sx={{ fontWeight: "bold", fontSize: "1.5rem" }}>Stability Settings</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ bgcolor: "background.light", p: 2 }}>
        {loading && <CircularProgress size={24} />}
        {error && (
          <Typography sx={{ textAlign: "center", color: "secondary.main" }}>
            {t("No Settings Found")}
          </Typography>
        )}
        {!loading && formState && (
          <StabilityForm
            stabilitySettings={formState}
            onChangeHandler={onChangeHandler}
            inputSelected={inputSelected}
          />
        )}
        {(isAuthorized || isEdge) && formState && (
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
            <Button variant="contained" size="small" onClick={handleSave}>{t("Save")}</Button>
          </Box>
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default StabilitySettings;
